module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_--black-opening-page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page15",
      "title": "15"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_ct",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("External Remedies")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Baths")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Adding herbs to a bath is a great way of getting the relaxing qualities of herbs (absorbed through the skin and inhaled) and for treating some skin conditions and aching muscles. You can put some herbs in a sock or muslin bag and drop this into the bath, but the bathwater isn’t really hot enough to extract the herbs’ qualities. The best way is to add 500 millilitres of herbal infusion or decoction (see "), _c('a', {
    attrs: {
      "href": "#/HKWH3#_idTextAnchor005"
    }
  }, [_vm._v("page 10")]), _vm._v(") to the bathwater and soak.")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Steam Inhalations")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Steam inhalations of herbs may be used to relieve cold symptoms (using peppermint, thyme, or ginger, for example). ")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-head"
  }, [_vm._v("Steam Inhalation (Basic Method)")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("1 litre boiling water")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("2 teaspoons herbs (fresh, if possible)")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-instructions"
  }, [_vm._v("Pour the boiling water over the herbs. With a towel over your head, inhale the vapour.")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page16",
      "title": "16"
    }
  }, [_vm._v("Salves"), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Herbs can be made into salves or ointments, which can then be applied to the affected area.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-head"
  }, [_vm._v("Salves (Folk Method 1)")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("200 grams petroleum jelly ")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("2 tablespoons herbs")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-instructions"
  }, [_vm._v("In a double boiler, simmer the herbs in the petroleum jelly for twenty minutes. Strain into glass jars.")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-head"
  }, [_vm._v("Salves (Folk Method 2)")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("250 millilitres oil")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("2 tablespoons herbs")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-ingredients"
  }, [_vm._v("150 grams beeswax, grated")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-instructions"
  }, [_vm._v("In a double boiler, simmer the herbs in the oil for twenty to forty minutes. Strain and return the oil to the pan, add the beeswax, and melt. Pour into warm glass jars. This is my preferred method. ")]), _vm._v(" "), _c('p', {
    staticClass: "recipe-instructions-para-2"
  }, [_vm._v("You can also set an infused oil (see "), _c('a', {
    attrs: {
      "href": "#/HKWH4#_idTextAnchor008"
    }
  }, [_vm._v("page 17")]), _vm._v(") into a salve using this method. Slightly warm your prepared oil and add the beeswax, allowing two tablespoons of grated beeswax to 500 millilitres of infused oil after the herbal material has been strained off. Pour into shallow jars to set. ")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_vm._v("Coconut Balms")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Coconut oil, solid at room temperature, is a perfect consistency for a simple balm. You can simply gently simmer your herbs at a low temperature in coconut oil for one to two hours, then strain into shallow jars to set. (I recently bought an electric chocolate melter from a discount supermarket for a few pounds, and this is perfect for the job.) Coconut adds its own benefits to a balm: it is anti-inflammatory and can reduce pain and swelling. It is intensely moisturising and contains antimicrobial lipids, lauric acid, capric acid, and caprylic acid, which have antifungal, antibacterial, and antiviral properties.")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page17",
      "title": "17"
    }
  }, [_vm._v("Compresses and Poultices")])]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Compresses and poultices are a way of applying the benefits of herbs externally to the skin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For a compress, soak a clean cotton cloth in a strong hot herbal infusion or decoction. Use this as hot as possible on the affected area (take care and do not burn yourself). Cover with a warm towel and leave for thirty minutes, and change the compress as it cools down by resoaking it in the infusion. Use one to two times a day. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whereas a compress uses a cloth soaked in a liquid herbal infusion, a poultice employs herbs directly applied to the skin and then covered with a warm cloth. Use a mortar and pestle to bruise fresh herbs, apply directly to the skin, and cover with a warm cloth. Use one to two times a day.")]), _vm._v(" "), _c('p', {
    staticClass: "a-head"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Infused Oils")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("Fats and oils extract the oily and resinous properties of a herb, and these are often the antibacterial, antifungal, and wound-healing components. Infused oils are used for external applications. Unlike essential oils, they do not need to be diluted for use. ")]), _vm._v(" "), _c('p', {
    staticClass: "b-head-all-lc"
  }, [_vm._v("cold infused oil (folk method)")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("To make a cold infused oil, cut up the herb, place in a glass bottle or jar,  and cover with vegetable oil such as olive, sunflower, almond, etc. Leave on a sunny windowsill for two weeks, shaking daily. Strain into a clean jar. This will keep in a cool, dark place for up to a year.")]), _vm._v(" "), _c('p', {
    staticClass: "b-head-all-lc"
  }, [_vm._v("heat-macerated oil (folk method)")]), _vm._v(" "), _c('p', {
    staticClass: "txni"
  }, [_vm._v("A hot maceration is quicker to make than a cold oil infusion. In a double boiler, put in the chopped herb and cover with a vegetable oil. Simmer very gently, covered, for two hours. Turn off the heat and allow the oil to cool before straining. If you wish, you can add fresh herbs to the oil and repeat the process for a stronger oil.")]), _vm._v(" "), _c('p', {
    staticClass: "contents _idGenParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#_idTextAnchor000"
    }
  }, [_vm._v("[contents]")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ce020de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HKWH-4.vue
// module id = 81
// module chunks = 0